import { render, staticRenderFns } from "./baozhuang.vue?vue&type=template&id=034b7bd5&scoped=true&"
import script from "./baozhuang.vue?vue&type=script&lang=js&"
export * from "./baozhuang.vue?vue&type=script&lang=js&"
import style0 from "./baozhuang.vue?vue&type=style&index=0&id=034b7bd5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034b7bd5",
  null
  
)

export default component.exports